'use strict';
import { FeedbackListBase } from './FeedbackListBase';
import Render from './FeedbackListRender';
import { connect } from 'react-redux';

class FeedbackList extends FeedbackListBase {
    render() {
        return Render.call(this, this.props, this.state);
    }
}

export default FeedbackList = connect((state)=>{
    return {user:state.user || {}}
})(FeedbackList);
